/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).on('change', '.ProductForm__Item', function(){
  if (BOLD && BOLD.recurring_orders && BOLD.recurring_orders.app && BOLD.recurring_orders.app.ee && typeof BOLD.recurring_orders.app.ee.emit === 'function') {
    BOLD.recurring_orders.app.ee.emit('variant_changed');
  }
});

! function(t, o) {
    var n = {};
    t.init = function() {
        n.gdprBanner = o(".gdpr-banner-container"), n.gdprCloseBanner = o(".close-gdpr-banner"), n.gdprLargeModal = o(".gdpr-large-modal-container"), n.gdprCloseLargeModal = o(".close-gdpr-large-modal"), n.gdprSmallModal = o(".gdpr-small-modal-container"), n.gdprCloseSmallModal = o(".close-gdpr-small-modal"), n.gdprCloseBanner.click(function() {
            n.gdprBanner.hide()
        }), n.gdprCloseLargeModal.click(function() {
            n.gdprLargeModal.hide()
        }), n.gdprCloseSmallModal.click(function() {
            n.gdprSmallModal.hide()
        })
    }
}(window.GDPRBannerAndModal = window.GDPRBannerAndModal || {}, jQuery),
function(t, o) {
    "use strict";
    t.debounce = function(t, o, n) {
        var i = void 0;
        return function() {
            var a = this,
                e = arguments,
                l = n && !i;
            clearTimeout(i), i = setTimeout(function() {
                i = null, n || t.apply(a, e)
            }, o), l && t.apply(a, e)
        }
    }
}(window.Helpers = window.Helpers || {}, jQuery),
function(t, o) {
    "use strict";
    var n = {};
    t.update = function(t) {
        o.get("/cart?view=contents", function(t) {
            n.inlineCart.html(t)
        })
    }, t.show = function() {
        n.inlineCart.addClass("is-active")
    }, t.hide = function() {
        n.inlineCart.removeClass("is-active")
    };
    t.init = function() {
        n.inlineCart = o("[data-inline-cart]"), n.lineItemEntryPoint = o("[data-cart-contents]")
    }
}(window.InlineCart = window.InlineCart || {}, jQuery),
function(t, o) {
    t.init = function() {
        new t
    }
}(window.LazyLoad = window.LazyLoad || {}, jQuery),
function(t, o) {
    var n = {},
        i = function() {
            o(".Collapsible__Button--state").toggleClass("is-active")
        };
    t.init = function() {
        n.mobileStateLink = o(".collapsible--state-link"), n.mobileStatePlusIcon = o(".collapsible-plus--state"), n.mobileStatePlusIcon.on("click", i)
    }
}(window.MobileNavigation = window.MobileNavigation || {}, jQuery),
function(t, o) {
    "use strict";
    var n = {};
    t.show = function(t) {
        return window.Overlay.show(), window.Scroll.lock(), n.body.attr("data-active-modal", t), o('[data-modal="' + t + '"]').fadeIn(300)
    }, t.hide = function() {
        return window.Overlay.hide(), window.Scroll.unlock(), n.body.removeAttr("data-active-modal"), n.modal.fadeOut(300)
    };
    t.init = function() {
        n.body = o("body"), n.modal = o("[data-modal]"), n.modalShow = o("[data-modal-show]"), n.modalHide = o("[data-modal-hide]"), n.modalShow.on("click", function(t) {
            t.preventDefault(), window.Modal.show(o(this).attr("data-modal-show"))
        }), n.modalHide.on("click", function(t) {
            t.preventDefault(), window.Modal.hide()
        })
    }
}(window.Modal = window.Modal || {}, jQuery),
function(t, o) {
    var n = '[name="id"]',
        i = ".ProductForm__AddToCart",
        a = ".ProductMeta__Price",
        e = function(t, n) {
            console.log("Variant:", t), t ? (o(i).removeAttr("disabled").addClass("Button--primary").removeClass("Button--secondary").attr("data-action", "add-to-cart").attr("data-cart-add", t.id).text("Add To Cart"), o(a).text(Shopify.formatMoney(t.price)), t.available || o(i).attr("disabled", "disabled").addClass("Button--secondary").removeClass("Button--primary").removeAttr("data-action").text("Sold out")) : o(i).attr("disabled", "disabled").removeAttr("data-action").addClass("Button--secondary").removeClass("Button--primary").text("Unavailable")
        };
    t.init = function() {
        var t, i;
        t = document.querySelector(n).getAttribute("id"), i = JSON.parse(o("#" + t).attr("data-product")), new Shopify.OptionSelectors("" + t, {
            product: i,
            onVariantSelected: e
        }), o('[name="variant-select"]').change(function() {
            var t = o(this).find("option:selected").attr("data-option-index"),
                n = o(this).val();
            o(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
        }), o(".ColorSwatch__Radio").change(function() {
            var t = o(this).attr("data-option-index"),
                n = o(this).val();
            o(this).closest("form").find(".single-option-selector").eq(t).val(n).trigger("change")
        })
    }
}(window.OptionSelection = window.OptionSelection || {}, jQuery),
function(t, o) {
    "use strict";
    var n = {};
    t.show = function() {
        return n.overlay.fadeIn(300)
    }, t.hide = function() {
        return n.overlay.fadeOut(300)
    }, t.toggle = function() {
        return n.overlay.fadeToggle(300)
    };
    t.init = function() {
        n.overlay = o("[data-overlay]"), n.overlay.on("click", window.Overlay.hide)
    }
}(window.Overlay = window.Overlay || {}, jQuery),
function(t, o) {
    "use strict";
    t.lock = function(t) {
        o("html, body").addClass("no-scroll")
    }, t.unlock = function(t) {
        o("html, body").removeClass("no-scroll")
    }, t.toggle = function(t) {
        o("html, body").toggleClass("no-scroll")
    };
    t.init = function() {}
}(window.Scroll = window.Scroll || {}, jQuery),
function(t, o) {
    t.ourStory = function(t) {
        t.includes(".") || (t = "." + t), o(t).slick({
            infinite: !0,
            arrows: !0,
            prevArrow: "<button type='button' class='slick-prev pull-left'> < </button>",
            nextArrow: "<button type='button' class='slick-next pull-right'> > </button>",
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: !0,
            responsive: [{
                breakpoint: 767,
                settings: {
                    arrows: !1,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    outerEdgeLimit: !0,
                    variableWidth: !0
                }
            }]
        })
    };
    t.init = function() {
        console.log("SlickInits")
    }
}(window.SlickInits = window.SlickInits || {}, jQuery);

if (document.body.classList.contains('out-story')) {
  SlickInits.ourStory('block-img');
}

MobileNavigation.init();
OptionSelection.init();